// extracted by mini-css-extract-plugin
export default {"modal-top-2-box":"ModalTop2Box_modal-top-2-box__vqBZs"};